/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useEffect } from 'react';
import { useClientLogContext } from 'src/contexts/ClientLogContext';
import { REACT_APP_NAME } from 'src/utils/constants/constants';
import { getMemoryUsage } from 'src/utils/miscUtils';
import { ClientLogRequest, LogLevel } from 'src/WebApiController';

function getTabId() {
  return sessionStorage.tabId
    ? sessionStorage.tabId
    : (sessionStorage.tabId = Math.random());
}

export const useMemoryTelemetry = () => {
  const { logEvent } = useClientLogContext();

  const INTERVAL_SECONDS = 300;

  const getMeasurement = useCallback(async () => {
    const memoryUsage = getMemoryUsage();

    if (memoryUsage.usedJSHeapSize != null) {
      const logRequest: ClientLogRequest = {
        logLevel: LogLevel.Information,
        applicationSource: REACT_APP_NAME,
        errorId: getTabId(),
        error: 'MemoryStat',
        pageUrl: window.location.href,
        componentStack: null,
        timestamp: new Date().toISOString(),
        additionalInfo: memoryUsage,
      };

      logEvent(logRequest);
    }
  }, [logEvent]);

  useEffect(() => {
    // Log immediately on mount
    getMeasurement();

    // Then set up the interval
    const timerId = setInterval(getMeasurement, 1000 * INTERVAL_SECONDS);

    return () => {
      clearInterval(timerId);
    };
  }, [getMeasurement]); // Remove memoryUsage from dependencies
};
